// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#container {
  width: 100% !important;
  max-width: none !important;
  padding: 0;
}

#outer-birthday-card {
  padding-right: 170px;
  padding-top: 0px;
}

#birthday-card {
  width: 678px;
  height: 600px;
  margin: 0 auto;
  /* padding: 20px; */
  /* border: 1px solid #ccc; */
  border-radius: 0px;
  /* background: #fff4f4; */
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */
    overflow: visible !important;
    position: relative;

   /* position: relative;
    overflow: visible !important; 
    width: 100%;
    width: 678px;
    height: 600px;*/

}

#birthday-card h1 {
  font-family: Arial, sans-serif;
}

#birthday-card p {
  font-size: 16px;
}

#birthday-card textarea {
  display: block;
  width: 90%;
  margin: 0 auto;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
  min-height: 80px;
  font-family: Arial, sans-serif;
}

#birthday-card .input {
  display: block;
  margin: 10px auto;
  padding: 10px;
  width: 90%;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

#birthday-card .select {
  display: block;
  margin: 10px auto;
  padding: 10px;
  width: 90%;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

#birthday-card .button {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  font-size: 16px;
  color: #fff;
  background-color: #ff4081;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

#birthday-card h1 {
  text-align: center; /* Center-align text */
  margin: 0; /* Remove default margin */
  white-space: pre-wrap; /* Preserve new lines */
}

#birthday-card p {
  text-align: center; /* Center-align text */
  margin: 0; /* Remove default margin */
  white-space: pre-wrap; /* Preserve new lines */
}

#birthday-card textarea {
  display: block;
  /* width: 90%; */
  margin: 0 auto;
  padding: 10px;
  font-size: 16px;
  border: 2px solid #21ba45 !important; /* Ensure light gray border with higher specificity */
  border-radius: 5px;
  font-family: Arial, sans-serif;
  text-align: center;
  resize: none; /* Disable manual resizing */
  outline: none; /* Remove focus outline for cleaner look */
}

#birthday-card textarea:focus {
  border-color: #aaa; /* Slightly darker gray on focus */
}

#birthday-card textarea::-webkit-scrollbar {
  width: 6px; /* Slightly wider scrollbar */
}

#birthday-card textarea::-webkit-scrollbar-thumb {
  background-color: #888; /* Color of the scrollbar thumb */
  border-radius: 4px; /* Rounded corners for the scrollbar thumb */
}

#birthday-card textarea::-webkit-scrollbar-thumb:hover {
  background-color: #555; /* Darker color on hover */
}

#birthday-card textarea::-webkit-scrollbar-track {
  background: #f1f1f1; /* Background color of the scrollbar track */
}

[contenteditable]:focus {
  outline: none !important;
  border: none !important;
}

#outer-birthday-card .preloader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8); /* Black background with opacity */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: 0.8;

  height: 100vh; /* Full viewport height */
}

#outer-birthday-card .preloader-wrapper {
  width: 80px;
  height: 80px;
}

#outer-birthday-card .spinner-layer {
  border-color: #ffffff !important;
}

#birthday-card-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 100vh;
}


/* Toast Container (Position at the Top Center) */
.toast-container {
  position: fixed !important;
  top: 16px !important; /* Distance from top */
  left: 50% !important; /* Center horizontally */
  transform: translateX(-50%) !important; /* Perfect centering */
  z-index: 9999 !important; /* Ensures it appears above other elements */
}

/* Toast Custom Size */
.toast-custom {
  width: 300px !important; /* Set width */
  height: 200px !important; /* Set height */
  min-height: 200px !important;
  text-align: center;
  font-size: 16px;
  padding: 20px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

/* Custom Colors */
.toast-green {
  background-color: #4caf50 !important;
  color: white !important;
}

.toast-red {
  background-color: #e53935 !important;
  color: white !important;
}

.toast-blue {
  background-color: #1e88e5 !important;
  color: white !important;
}






`, "",{"version":3,"sources":["webpack://./src/components/birthday/BirthdayCard.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,8CAA8C;IAC5C,4BAA4B;IAC5B,kBAAkB;;GAEnB;;;;mBAIgB;;AAEnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,cAAc;EACd,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB,EAAE,sBAAsB;EAC1C,SAAS,EAAE,0BAA0B;EACrC,qBAAqB,EAAE,uBAAuB;AAChD;;AAEA;EACE,kBAAkB,EAAE,sBAAsB;EAC1C,SAAS,EAAE,0BAA0B;EACrC,qBAAqB,EAAE,uBAAuB;AAChD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,oCAAoC,EAAE,qDAAqD;EAC3F,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY,EAAE,4BAA4B;EAC1C,aAAa,EAAE,0CAA0C;AAC3D;;AAEA;EACE,kBAAkB,EAAE,kCAAkC;AACxD;;AAEA;EACE,UAAU,EAAE,6BAA6B;AAC3C;;AAEA;EACE,sBAAsB,EAAE,iCAAiC;EACzD,kBAAkB,EAAE,4CAA4C;AAClE;;AAEA;EACE,sBAAsB,EAAE,0BAA0B;AACpD;;AAEA;EACE,mBAAmB,EAAE,4CAA4C;AACnE;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,kCAAkC;EAClE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;;EAEZ,aAAa,EAAE,yBAAyB;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;;AAGA,iDAAiD;AACjD;EACE,0BAA0B;EAC1B,oBAAoB,EAAE,sBAAsB;EAC5C,oBAAoB,EAAE,wBAAwB;EAC9C,sCAAsC,EAAE,sBAAsB;EAC9D,wBAAwB,EAAE,4CAA4C;AACxE;;AAEA,sBAAsB;AACtB;EACE,uBAAuB,EAAE,cAAc;EACvC,wBAAwB,EAAE,eAAe;EACzC,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB","sourcesContent":["#container {\r\n  width: 100% !important;\r\n  max-width: none !important;\r\n  padding: 0;\r\n}\r\n\r\n#outer-birthday-card {\r\n  padding-right: 170px;\r\n  padding-top: 0px;\r\n}\r\n\r\n#birthday-card {\r\n  width: 678px;\r\n  height: 600px;\r\n  margin: 0 auto;\r\n  /* padding: 20px; */\r\n  /* border: 1px solid #ccc; */\r\n  border-radius: 0px;\r\n  /* background: #fff4f4; */\r\n  /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */\r\n    overflow: visible !important;\r\n    position: relative;\r\n\r\n   /* position: relative;\r\n    overflow: visible !important; \r\n    width: 100%;\r\n    width: 678px;\r\n    height: 600px;*/\r\n\r\n}\r\n\r\n#birthday-card h1 {\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n#birthday-card p {\r\n  font-size: 16px;\r\n}\r\n\r\n#birthday-card textarea {\r\n  display: block;\r\n  width: 90%;\r\n  margin: 0 auto;\r\n  padding: 10px;\r\n  font-size: 16px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n  min-height: 80px;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n#birthday-card .input {\r\n  display: block;\r\n  margin: 10px auto;\r\n  padding: 10px;\r\n  width: 90%;\r\n  font-size: 16px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n}\r\n\r\n#birthday-card .select {\r\n  display: block;\r\n  margin: 10px auto;\r\n  padding: 10px;\r\n  width: 90%;\r\n  font-size: 16px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n}\r\n\r\n#birthday-card .button {\r\n  display: block;\r\n  margin: 20px auto;\r\n  padding: 10px 20px;\r\n  font-size: 16px;\r\n  color: #fff;\r\n  background-color: #ff4081;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n#birthday-card h1 {\r\n  text-align: center; /* Center-align text */\r\n  margin: 0; /* Remove default margin */\r\n  white-space: pre-wrap; /* Preserve new lines */\r\n}\r\n\r\n#birthday-card p {\r\n  text-align: center; /* Center-align text */\r\n  margin: 0; /* Remove default margin */\r\n  white-space: pre-wrap; /* Preserve new lines */\r\n}\r\n\r\n#birthday-card textarea {\r\n  display: block;\r\n  /* width: 90%; */\r\n  margin: 0 auto;\r\n  padding: 10px;\r\n  font-size: 16px;\r\n  border: 2px solid #21ba45 !important; /* Ensure light gray border with higher specificity */\r\n  border-radius: 5px;\r\n  font-family: Arial, sans-serif;\r\n  text-align: center;\r\n  resize: none; /* Disable manual resizing */\r\n  outline: none; /* Remove focus outline for cleaner look */\r\n}\r\n\r\n#birthday-card textarea:focus {\r\n  border-color: #aaa; /* Slightly darker gray on focus */\r\n}\r\n\r\n#birthday-card textarea::-webkit-scrollbar {\r\n  width: 6px; /* Slightly wider scrollbar */\r\n}\r\n\r\n#birthday-card textarea::-webkit-scrollbar-thumb {\r\n  background-color: #888; /* Color of the scrollbar thumb */\r\n  border-radius: 4px; /* Rounded corners for the scrollbar thumb */\r\n}\r\n\r\n#birthday-card textarea::-webkit-scrollbar-thumb:hover {\r\n  background-color: #555; /* Darker color on hover */\r\n}\r\n\r\n#birthday-card textarea::-webkit-scrollbar-track {\r\n  background: #f1f1f1; /* Background color of the scrollbar track */\r\n}\r\n\r\n[contenteditable]:focus {\r\n  outline: none !important;\r\n  border: none !important;\r\n}\r\n\r\n#outer-birthday-card .preloader-container {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.8); /* Black background with opacity */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 9999;\r\n  opacity: 0.8;\r\n\r\n  height: 100vh; /* Full viewport height */\r\n}\r\n\r\n#outer-birthday-card .preloader-wrapper {\r\n  width: 80px;\r\n  height: 80px;\r\n}\r\n\r\n#outer-birthday-card .spinner-layer {\r\n  border-color: #ffffff !important;\r\n}\r\n\r\n#birthday-card-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  min-height: 100vh;\r\n}\r\n\r\n\r\n/* Toast Container (Position at the Top Center) */\r\n.toast-container {\r\n  position: fixed !important;\r\n  top: 16px !important; /* Distance from top */\r\n  left: 50% !important; /* Center horizontally */\r\n  transform: translateX(-50%) !important; /* Perfect centering */\r\n  z-index: 9999 !important; /* Ensures it appears above other elements */\r\n}\r\n\r\n/* Toast Custom Size */\r\n.toast-custom {\r\n  width: 300px !important; /* Set width */\r\n  height: 200px !important; /* Set height */\r\n  min-height: 200px !important;\r\n  text-align: center;\r\n  font-size: 16px;\r\n  padding: 20px !important;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 10px;\r\n}\r\n\r\n/* Custom Colors */\r\n.toast-green {\r\n  background-color: #4caf50 !important;\r\n  color: white !important;\r\n}\r\n\r\n.toast-red {\r\n  background-color: #e53935 !important;\r\n  color: white !important;\r\n}\r\n\r\n.toast-blue {\r\n  background-color: #1e88e5 !important;\r\n  color: white !important;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
